import { RouteConfig } from "vue-router";

const cajaChicasTalcaGerencial: RouteConfig = {
  path: "/cajaChicasTalcaGerencial",
  name: "cajaChicasTalcaGerencial",
  component: () => import(/* webpackChunkName: "caja-chicas-talca-gerencial" */ "@/views/CajaChicasTalcaGerencial.vue"),
};

export default cajaChicasTalcaGerencial;
